import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Package, ChevronRight } from 'lucide-react';
import api from '../utils/api';
import './OrdersPage.css';

const STATUS_COLORS = {
  pending: '#f59e0b', confirmed: '#3b82f6', processing: '#8b5cf6',
  shipped: '#06b6d4', delivered: '#10b981', cancelled: '#ef4444'
};

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/orders/my').then(res => { setOrders(res.data.orders); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 100 }}><div className="spinner" /></div>;

  return (
    <div className="orders-page container">
      <h1>My Orders</h1>
      {orders.length === 0 ? (
        <div className="no-orders">
          <Package size={64} />
          <h3>No orders yet</h3>
          <Link to="/shop" className="btn-primary">Start Shopping</Link>
        </div>
      ) : (
        <div className="orders-list">
          {orders.map(order => (
            <Link key={order._id} to={`/orders/${order._id}`} className="order-card">
              <div className="order-left">
                <strong>{order.orderNumber}</strong>
                <span>{new Date(order.createdAt).toLocaleDateString()}</span>
                <span>{order.items?.length} item(s)</span>
              </div>
              <div className="order-status" style={{ color: STATUS_COLORS[order.orderStatus] }}>
                ● {order.orderStatus}
              </div>
              <div className="order-total">CHF {order.total?.toFixed(2)}</div>
              <ChevronRight size={20} className="order-arrow" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
